import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowButton } from '../ui/ArrowButton';
import { Reveal } from '../ui/Reveal';
import { SectionLabel } from '../ui/SectionLabel';
import { SplitText } from '../ui/SplitText';
import { posts } from '../../data/posts';
export function BlogPreview() {
  const [main, ...rest] = posts;
  const side = rest.slice(0, 3);
  return <section className="bg-white py-24 lg:py-36" data-id="element-70" data-mp="3czt0ejbzay0q">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8" data-id="element-71" data-mp="3czas2oc1ktcg">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-72" data-mp="3806lm5gi59pt">
          <div data-id="element-73" data-mp="331d7cate5eol">
            <Reveal data-id="element-74" data-mp="330tzxo1da8ot">
              <SectionLabel data-id="element-75" data-mp="330br7rxiq200">Blog</SectionLabel>
            </Reveal>
            <h2 className="mt-6 max-w-2xl text-[clamp(2rem,4vw,3.25rem)] font-medium leading-[1.08] tracking-[-0.03em]" data-id="element-76" data-mp="2y31x3yz6p25u">
              <SplitText text="Analyses et conseils pour mieux acheter." data-id="element-77" data-mp="1rnj1sns79pn4" />
            </h2>
          </div>
          <Reveal delay={0.1} data-id="element-78" data-mp="1mmlpgrtvfptj">
            <ArrowButton to="/blog" data-id="element-79" data-mp="1mphneg5pyehz">Tous les articles</ArrowButton>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-80" data-mp="s9h2wcqwxywz">
          <Reveal className="lg:col-span-7" data-id="element-81" data-mp="x9bt0e2v6kgz">
            <Link to={`/blog/${main.slug}`} className="group block" data-id="element-82" data-mp="ide3heng4edq">
              <div className="aspect-[16/10] overflow-hidden rounded-[28px]" data-id="element-83" data-mp="id4enue50d9m">
                <img src={main.image} alt="" className="h-full w-full object-cover transition-transform duration-300 ease-out-strong group-hover:scale-[1.04]" data-id="element-84" data-mp="nb5t220mboer" />
              </div>
              <div className="mt-6 flex items-center gap-3 text-sm text-muted" data-id="element-85" data-mp="3vsac6dcns1lc">
                <span className="rounded-md bg-ink/[0.06] px-2.5 py-1 text-ink" data-id="element-86" data-mp="3vqfst3h1chjd">{main.category}</span>
                <span data-id="element-87" data-mp="4jmss2xzaogf">{main.date}</span>
                <span aria-hidden="true" data-id="element-88" data-mp="3mrcai1pp065x">·</span>
                <span data-id="element-89" data-mp="3mtoz2xpyhery">{main.readTime} de lecture</span>
              </div>
              <h3 className="mt-4 max-w-2xl text-[clamp(1.5rem,2.4vw,2rem)] font-medium leading-tight tracking-tight transition-colors duration-150 group-hover:text-brass-dark" data-id="element-90" data-mp="3qrw8t8m05ftn">
                {main.title}
              </h3>
              <p className="mt-3 max-w-2xl leading-relaxed text-muted" data-id="element-91" data-mp="1shnl7ihqqi24">{main.excerpt}</p>
            </Link>
          </Reveal>

          <ul className="divide-y divide-ink/10 lg:col-span-5" data-id="element-92" data-mp="1ilua83jo6wmg">
            {side.map((post, i) => <li key={post.slug} data-id="element-93" data-mp="2g92u5u40vxmc" data-mpi={i}>
                <Reveal delay={0.08 * (i + 1)} data-id="element-94" data-mp="2g8039m6p9v6f">
                  <Link to={`/blog/${post.slug}`} className="group grid grid-cols-[112px_1fr] gap-5 py-6 first:pt-0 sm:grid-cols-[140px_1fr]" data-id="element-95" data-mp="2ba89emmhvyzl">
                    <div className="aspect-square overflow-hidden rounded-2xl" data-id="element-96" data-mp="269u0l2d2kl0i">
                      <img src={post.image} alt="" className="h-full w-full object-cover transition-transform duration-300 ease-out-strong group-hover:scale-[1.06]" data-id="element-97" data-mp="22abgu9wzifz9" />
                    </div>
                    <div data-id="element-98" data-mp="32hzze91xy2rq">
                      <p className="text-sm text-muted" data-id="element-99" data-mp="32irmswldwu6x">
                        {post.category} · {post.readTime}
                      </p>
                      <h3 className="mt-2 text-lg font-medium leading-snug transition-colors duration-150 group-hover:text-brass-dark" data-id="element-100" data-mp="36h8sdbp5pwm8">
                        {post.title}
                      </h3>
                    </div>
                  </Link>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}